import React, { useCallback, useMemo } from 'react';
import { Menu, MenuItem, Tooltip } from '@doxyme/ui';
import { openCallSettingsFromMenu } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { getIsCaptionsOpen, toggleClosedCaptionsOpen } from '../../../captions';
import { openBackgroundEffectsModal } from '../../../core/actions';
import * as troubleshooting from '../../../troubleshooting';
import { useIntl } from 'react-intl';
import { noop } from 'lodash';
import { utils, hasGrowthBookFeature, GrowthBookFeatures, canSeeBackgroundEffects, } from '../../../core';
const translationsKeyMap = {
    settings: 'call.actions.options.items.settings',
    troubleshooting: 'call.actions.options.items.troubleshooting',
    backgroundEffects: 'backgroundEffects.title',
    backgroundEffectsTooltip: 'backgroundEffects.tooltip',
    closedCaptions: 'call.actions.options.items.closedCaptions',
};
export const CallMenu = ({ isPatient, toggleMenu = noop, }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const localized = useMemo(() => utils.formatObjectValues(translationsKeyMap, (value) => intl.formatMessage({ id: value })), []);
    const isBackgroundEffectsEnabled = useMemo(() => canSeeBackgroundEffects(), []);
    const isClosedCaptionsOpen = useSelector(getIsCaptionsOpen);
    const onBackgroundEffects = useCallback(() => {
        toggleMenu(false);
        dispatch(openBackgroundEffectsModal('call menu'));
    }, []);
    const onTroubleshooting = useCallback(() => {
        dispatch(troubleshooting.actions.openTroubleshooting());
    }, []);
    const onClosedCaptions = () => {
        toggleMenu(false);
        dispatch(toggleClosedCaptionsOpen(!isClosedCaptionsOpen, isPatient));
    };
    const onCallSettings = useCallback(() => {
        toggleMenu(false);
        dispatch(openCallSettingsFromMenu(isPatient));
    }, [isPatient]);
    return (<Menu>
      {isBackgroundEffectsEnabled && (<Tooltip size="medium" theme="light" pointerPosition="top-center" positionShift={8} isInteractive={false} borderRadius={16} isDefaultTriggerPadding={false} content={localized.backgroundEffectsTooltip}>
          <MenuItem text={localized.backgroundEffects} icon="visual-effects" onSelect={onBackgroundEffects} aria-label="Background Effects"/>
        </Tooltip>)}
      {hasGrowthBookFeature(GrowthBookFeatures.ClosedCaptions) && (<MenuItem text={localized.closedCaptions} icon="closed-captions" onSelect={onClosedCaptions} aria-label="Closed Captions" disabled={isClosedCaptionsOpen}/>)}
      <MenuItem text={localized.troubleshooting} icon="troubleshooting" onSelect={onTroubleshooting} aria-label="Troubleshooting"/>
      <MenuItem text={localized.settings} icon="call-settings" onSelect={onCallSettings} aria-label="Settings"/>
    </Menu>);
};
